import React, { useState, useEffect, useCallback } from "react";
import {
    Box,
    Typography,
    Button,
    Avatar,
    IconButton,
    Tooltip,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import HomeIcon from '@mui/icons-material/Home';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Breadcrumbs, Link } from "@mui/material";
import ModalSecretaria from "./ModalSecretaria";
import ModalExcluirSecretaria from "./ModalExcluirSecretaria";
import AlertSuccess from "../../components/AlertSuccess";
import AlertError from "../../components/AlertError";

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const cabecalhoSx = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: "#6b7280", textTransform: "uppercase", borderBottom: "none", py: 1 };
const celulaSx = { fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6", py: 1.25 };

const iniciais = (texto) =>
    String(texto ?? "").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");

const Secretarias = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    const [busca, setBusca] = useState("");
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [secretarias, setSecretarias] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [openModalSecretaria, setOpenModalSecretaria] = useState(false);
    const [openModalExcluir, setOpenModalExcluir] = useState(false);
    // Secretária selecionada para editar/excluir; null no modal = novo cadastro
    const [secretariaSelecionada, setSecretariaSelecionada] = useState(null);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");

    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;
        setUserActive(!hasFaturasVencidas);
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    const getSecretarias = useCallback(async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarSecretarias`, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });
            if (response.data.status === 200) {
                console.log("Secretarias:", response.data.secretarias);
                setSecretarias(response.data.secretarias ?? []);
            }
        } catch (error) {
            setMensagem("Nenhuma secretária encontrada.");
            setOpenSnackbarError(true);
        } finally {
            setCarregando(false);
        }
    }, []);

    useEffect(() => {
        getSecretarias();
    }, [getSecretarias]);

    const abrirCadastro = () => {
        setSecretariaSelecionada(null);
        setOpenModalSecretaria(true);
    };

    const abrirEdicao = (secretaria) => {
        setSecretariaSelecionada(secretaria);
        setOpenModalSecretaria(true);
    };

    const abrirExclusao = (secretaria) => {
        setSecretariaSelecionada(secretaria);
        setOpenModalExcluir(true);
    };

    const handleSuccess = (texto) => {
        setOpenModalSecretaria(false);
        setOpenModalExcluir(false);
        setMensagem(texto);
        setOpenSnackbarSuccess(true);
        getSecretarias();
    };

    const handleError = (texto) => {
        setOpenModalExcluir(false);
        setMensagem(texto);
        setOpenSnackbarError(true);
    };

    // Filtra na renderização para a busca continuar valendo quando a lista é recarregada
    const termoBusca = busca.trim().toLowerCase();
    const secretariasFiltradas = termoBusca
        ? secretarias.filter((secretaria) =>
            String(secretaria.nome ?? "").toLowerCase().includes(termoBusca) ||
            String(secretaria.email ?? "").toLowerCase().includes(termoBusca)
        )
        : secretarias;

    const botaoPrincipalSx = { textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", px: 2, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } };

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <GroupsOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Secretárias
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Secretárias
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Gerencie quem tem acesso ao painel da sua empresa para auxiliar na rotina do consultório.
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate("../Dashboard")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Voltar
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<PersonAddAltOutlinedIcon />}
                            onClick={abrirCadastro}
                            sx={botaoPrincipalSx}
                        >
                            Nova secretária
                        </Button>
                    </Box>
                </Box>

                <Box sx={{ ...cardSx, mt: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", mb: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <GroupsOutlinedIcon sx={{ fontSize: 20 }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>Secretárias cadastradas</Typography>
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                    {secretarias.length} {secretarias.length === 1 ? "secretária" : "secretárias"} no total
                                </Typography>
                            </Box>
                        </Box>
                        <TextField
                            placeholder="Buscar por nome ou e-mail"
                            size="small"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            sx={{ width: { xs: "100%", sm: 320 }, "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff", fontSize: 13 } }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search sx={{ fontSize: 18, color: "#6b7280" }} />
                                        </InputAdornment>
                                    )
                                }
                            }}
                        />
                    </Box>

                    <TableContainer sx={{ overflowX: "auto" }}>
                        <Table sx={{ minWidth: 560 }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f3f4f6", "& th:first-of-type": { borderRadius: "6px 0 0 6px" }, "& th:last-of-type": { borderRadius: "0 6px 6px 0" } }}>
                                    <TableCell sx={cabecalhoSx}>Nome</TableCell>
                                    <TableCell sx={cabecalhoSx}>E-mail</TableCell>
                                    <TableCell sx={{ ...cabecalhoSx, width: 110 }} align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {carregando ? (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center" sx={{ borderBottom: "none", py: 6 }}>
                                            <CircularProgress size={28} sx={{ color: "#0b243d" }} />
                                        </TableCell>
                                    </TableRow>
                                ) : secretariasFiltradas.length > 0 ? (
                                    secretariasFiltradas.map((secretaria) => (
                                        <TableRow key={secretaria.idUsuario} hover>
                                            <TableCell sx={celulaSx}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                                                    <Avatar variant="rounded" sx={{ width: 30, height: 30, fontSize: 11, fontWeight: 700, color: "#ffc845", backgroundColor: "#0b243d", borderRadius: "6px" }}>
                                                        {iniciais(secretaria.usuario.nome)}
                                                    </Avatar>
                                                    <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>{secretaria.usuario.nome}</Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={celulaSx}>{secretaria.usuario.email}</TableCell>
                                            <TableCell sx={celulaSx} align="center">
                                                <Tooltip title="Editar">
                                                    <IconButton size="small" aria-label={`Editar ${secretaria.usuario.nome}`} onClick={() => abrirEdicao(secretaria)} sx={{ color: "#374151" }}>
                                                        <EditOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Excluir">
                                                    <IconButton size="small" aria-label={`Excluir ${secretaria.usuario.nome}`} onClick={() => abrirExclusao(secretaria)} sx={{ color: "#dc2626" }}>
                                                        <DeleteOutlineIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center" sx={{ borderBottom: "none", py: 6 }}>
                                            <GroupsOutlinedIcon sx={{ fontSize: 36, color: "#d1d5db" }} />
                                            <Typography sx={{ mt: 1, fontSize: 14, fontWeight: 600, color: "#374151" }}>
                                                Nenhuma secretária encontrada.
                                            </Typography>
                                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                                {secretarias.length > 0 ? "Tente buscar por outro nome ou e-mail." : "Cadastre uma secretária para dar acesso ao painel."}
                                            </Typography>
                                            {secretarias.length === 0 && (
                                                <Button
                                                    variant="contained"
                                                    startIcon={<PersonAddAltOutlinedIcon />}
                                                    onClick={abrirCadastro}
                                                    sx={{ ...botaoPrincipalSx, mt: 2 }}
                                                >
                                                    Nova secretária
                                                </Button>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ mt: 2, backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, py: 1 }}>
                        <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                            Exibindo <Box component="span" sx={{ color: "#111827", fontWeight: 700 }}>{secretariasFiltradas.length}</Box> de {secretarias.length} secretárias
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <ModalSecretaria
                open={openModalSecretaria}
                secretaria={secretariaSelecionada}
                onClose={() => setOpenModalSecretaria(false)}
                onSuccess={handleSuccess}
            />
            <ModalExcluirSecretaria
                open={openModalExcluir}
                secretaria={secretariaSelecionada}
                onClose={() => setOpenModalExcluir(false)}
                onSuccess={handleSuccess}
                onError={handleError}
            />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
        </>
    );
};

export default Secretarias;
